export const PHOTO_MATCH_CATEGORIES = {
	passport_id: {
		label: 'Паспорт / ID',
		promptHint: 'паспорт, удостоверение личности, ID-карта',
	},
	bank_card: {
		label: 'Банковская карта',
		promptHint: 'банковская карта (видна карта или номер)',
	},
	bank_screenshot: {
		label: 'Скрин банка',
		promptHint: 'скриншот банковского приложения, баланс, перевод',
	},
	payment_sms: {
		label: 'SMS / чек с деньгами',
		promptHint: 'SMS или чек с суммой, платёж, квитанция',
	},
	financial_document: {
		label: 'Финансовый документ',
		promptHint: 'договор, выписка, финансовый документ с личными данными',
	},
	selfie_kyc: {
		label: 'Селфи / фото лица (KYC)',
		promptHint:
			'селфи, фото лица крупным планом, портрет человека, фото пригодное для верификации/KYC (лицо чётко видно, анфас или 3/4)',
	},
} as const;

export type PhotoMatchCategoryId = keyof typeof PHOTO_MATCH_CATEGORIES;

export const PHOTO_MATCH_CATEGORY_IDS = Object.keys(PHOTO_MATCH_CATEGORIES) as PhotoMatchCategoryId[];

export function isPhotoMatchCategoryId(value: string): value is PhotoMatchCategoryId {
	return value in PHOTO_MATCH_CATEGORIES;
}

export function getPhotoMatchCategoryLabel(id: PhotoMatchCategoryId): string {
	return PHOTO_MATCH_CATEGORIES[id].label;
}
